// Get data of a defined shape from an API
export default async function request<TResponse>(
  url: string,
  config?: RequestInit
): Promise<TResponse> {
  let done = 0;
  while (done < 5) {
    try {
      const response = await fetch(url, config);
      done++;
      return await response.json();
    } catch (e) {
      console.error("API Request failed, retrying", e);
    }
  }
  throw new Error("API Request failed after 5 retries");
}

// Post to an api expecting nothing back
export async function post(
  url: string,
  config?: RequestInit
): Promise<Response> {

  return await fetch(url,{...config, method:"POST"})
}

// Post to an api expecting something back
export async function postWithResponse<TResponse>(
  url: string,
  config?: RequestInit
): Promise<TResponse> {
  const response = await fetch(url,{...config, method:"POST"})
  return await response.json();
}